export default {
  mock: {
    config: {},
    headers: {},
    status: 200,
    statusText: '',
    data: {
      tenantId: "tenants002",
      name: "アイラ株式会社",
      nameKana: "アイラカブシキカイシャ",
      address: "東京都千代田区",
      sectionName: "地域サポート部門",
      staffName: "どい",
      tel: "03-3333-3333",
      email: "bbb@bbb.com",
      note: "note",
      status: 1,
      communityCount: 1,
      createdAt: 1594880785395,
      updatedAt: 1594880785395
    }
  }
}